import Layout from '@/modules/layout/components/layout';
import Permissions from '@/security/permissions';
import { storeAsync } from '../../app-module';

const IssuedDocumentList = () => import('@/modules/issued-document/pages/IssuedDocumentList.vue');

const getIssuedDocumentModule = () => import('@/modules/issued-document/issued-document-store');
const importIssuedDocumentStore = () =>
    getIssuedDocumentModule().then((storeModule) => {
        if (!storeAsync().hasModule('issuedDocument')) storeAsync().registerModule('issuedDocument', storeModule.default);
        else return;
    });

export default [
    {
        path: '',
        component: Layout,
        meta: { auth: true },
        children: [
            {
                name: 'issuedDocuments',
                path: '/issued-documents',
                component: IssuedDocumentList,
                meta: {
                    auth: true,
                    permission: Permissions.values.issuedDocumentView,
                },
                beforeEnter: (to, from, next) => {
                    importIssuedDocumentStore().then(() => {
                        next();
                    });
                },
            },
        ],
    },
];
